<template>
  <v-container>
    <h2 
      class="customTitle"
    >설정</h2>
    <nickname />

    <ul class="configList">
      <li>
        <span>알람</span>
        <push />
      </li>
      <li>
        <span style="color: #ffb5cc">도전</span>
        <finish />
      </li>
      <li>
        <router-link to="/policy">
          <span>개인정보처리방침</span>
          <v-icon>mdi-chevron-right</v-icon>
        </router-link>
      </li>
      <li>
        <router-link to="/terms">
          <span>이용약관</span>
          <v-icon>mdi-chevron-right</v-icon>
        </router-link>
      </li>
      <li>
        <a href="#" target="_blank">
          <span>문의하기</span>
          <v-icon>mdi-chevron-right</v-icon>
        </a>
      </li>
    </ul>

    <div class="text-center">
      <v-btn 
        class="customButton gray" 
        @click="$router.push('/logout')"
      >로그아웃</v-btn>
    </div>
  </v-container>
</template>
<script>
import Finish from "../../components/config/Finish.vue";
import Nickname from "../../components/config/Nickname.vue";
import Push from "../../components/config/Push.vue";
export default {
  name: "Config",
  components: {
    Nickname,
    Push,
    Finish,
  },
};
</script>
<style lang="scss" scoped>
.configList{
  padding: 0;
  margin-bottom: 40px;

  li{
    padding: 8px 0;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span{
      font-size: 14px;
      font-weight: 700;
      letter-spacing: -0.5px;
    }
    a{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #222;
    }
  }
}
</style>
